module.exports = __webpack_public_path__ + "static/web.config";


//////////////////
// WEBPACK FOOTER
// ./src/web.config
// module id = 9z3D
// module chunks = 1 2 3 4 5 6 7 8